export function toPluralEntity(entity) {
    const normalized = entity?.toLowerCase() ?? '';
    const map = {
        project: 'projects',
        projects: 'projects',
        model: 'models',
        models: 'models',
        style: 'styles',
        styles: 'styles',
        expression: 'expressions',
        expressions: 'expressions',
        product: 'products',
        products: 'products'
    };
    if (map[normalized])
        return map[normalized];
    return normalized.endsWith('s') ? normalized : `${normalized}s`;
}
export const KNOWN_LINE_PLAN_ENTITY_IDS = new Set([
    'project',
    'product',
    'style',
    'expression',
    'model',
    'projects',
    'products',
    'styles',
    'expressions',
    'models'
]);
export function isKnownLinePlanEntityId(id) {
    return KNOWN_LINE_PLAN_ENTITY_IDS.has((id || '').toLowerCase());
}
/**
 * Path to the placeholder project image used as a fallback.
 */
export const PLACEHOLDER_PROJECT_IMAGE_URL = '/assets/projects/placeholder-project.png';
